// extracted by mini-css-extract-plugin
export var box = "Checkbox-mps-module--box--c8a90";
export var checkboxWrapper = "Checkbox-mps-module--checkboxWrapper--36766";
export var input = "Checkbox-mps-module--input--4a49c";
export var inputWrapper = "Checkbox-mps-module--inputWrapper--2325f";
export var label = "Checkbox-mps-module--label--ebbae";
export var outline = "Checkbox-mps-module--outline--f23c1";